import { render, staticRenderFns } from "./OptionCheck.vue?vue&type=template&id=a5b3a866&scoped=true"
import script from "./OptionCheck.vue?vue&type=script&lang=js"
export * from "./OptionCheck.vue?vue&type=script&lang=js"
import style0 from "./OptionCheck.vue?vue&type=style&index=0&id=a5b3a866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b3a866",
  null
  
)

export default component.exports